module.exports = __webpack_public_path__ + "img/icon-attention-grey.a8645c96.svg";